<script>
import shiny from '@rikschennink/shiny/dist/shiny.umd'
import StoresServices from '@/services/stores'
import LoyaltyCardServices from '@/services/loyaltyCards'
import LoyaltyCardFrame from '@/frames/loyaltyCardFrame'
import EnvironmentUtils from '@/utils/environmentUtils'
import DOMUtils from '@/utils/DOMUtils'
import ParticlesUtils from '@/utils/particlesUtils'
import LoyaltyCardStoreBalanceCard from '@/components/LoyaltyCardStoreBalanceCard'
import LoadingDots from '@/components/LoadingDots'
import Countdown from '@/components/Countdown'
import LoyaltyCard from '@/components/LoyaltyCard'
import BackgroundIllustration from '@/components/BackgroundIllustration'
import AlertBubble from '@/components/AlertBubble'
import DeviceUtils from '@/utils/deviceUtils'
import DialogUtils from '@/utils/dialogUtils'
import AsyncUtils from '@/utils/asyncUtils'
import ArrayUtils from '@/utils/arrayUtils'

export default
{
    name: 'loyalty-card-overview',

    created ()
    {
        StoresServices.fetchStores(EnvironmentUtils.cityId).then(stores  =>
        {
            this.$store.commit('stores/updateStoreList', stores)
        })
        LoyaltyCardFrame.initFrame(this.$store)
    },

    render () 
    {
        if (!this.card || !this.card.cardId) return

        const totalStores = this.card.balance.filter(b => b.points > 0)
        const pointsEnding = this.cardCumuledBalance > 1 ? 's' : ''
        const storesEnding = totalStores.length > 1 ? 's' : ''

        return (
            <div id='loyalty-card-overview-view'>
                <alert-bubble alert-id='loyaltycardprep-546'>
                    Nos commerçants se préparent à recevoir votre carte, certains commerces vont graduellement commencer à l'accepter dans les prochains mois ✨
                </alert-bubble>
                <div class='row stats'>
                    <div id='credit-info'>
                        <div class='description'>Point{pointsEnding} Disponible{pointsEnding}</div>
                        <div class='value'>{this.cardCumuledBalance}<div class='sub-value' v-show={this.cardCumuledBalance > 0}>dans {totalStores.length} commerce{storesEnding}</div></div>
                    </div>
                    <div id='help-sign'>
                        <div id='help-text'>Toucher pour scanner</div>
                        <inline-svg src={require('@/assets/img/semicircular-up-arrow.svg')} id='help-arrow' />
                    </div>
                </div>
                <loyalty-card card-id={this.card.cardId} ref='card' on-click={this.onCardClicked}>
                    { this.scanCode
                        ? <div class='scan-code'>
                            <div class='message'>Communiquez ce code à votre commerçant afin qu'il crédite votre carte :</div>
                            <div class='code'>{this.scanCode.code}</div>
                            <div class='expiration'>
                                Expire dans
                                <countdown date={new Date(this.scanCode.expiresAt)} on-expired={this.generateScanCode} />
                            </div>
                        </div>
                        : <loading-dots />
                    }
                </loyalty-card>
                <div class='list' v-show={this.card.balance.length > 0}>
                    <div class='title'>Mes Soldes</div>
                    <div class='description'>Cliquez sur le commerce de votre choix pour dépenser vos points de fidélité</div>
                    <div class='elements'>
                    {
                        this.card.balance.filter(b => b.points > 0).map(balance =>
                        {
                            const store = this.$store.getters.stores.getStoreById(balance.storeId)
                            const config = this.storeCardConfigs[store.id]
                            if (!store || !config) return

                            return <loyalty-card-store-balance-card store={store} store-config={config} balance={balance}
                                on-click={() => this.onStoreBalanceCardClicked(store)} />
                        })
                    }
                    </div>
                </div>
                <div class='list' v-show={this.latestRewards.length == 0 && this.latestCredits.length == 0}>
                    <background-illustration image={require('@/assets/img/shopping-bag.svg')} message="Vous n'avez aucun solde de disponible.
                        Présentez cette carte à vos commerçants lors de vos futurs achats pour commencer à collecter des points !" />
                </div>
                <div class='list' v-show={this.latestCredits.length > 0}>
                    <div class='title'>Derniers Crédits</div>
                    <div class='elements'>
                    {
                        this.latestCredits.map(credit =>
                        {
                            const store = this.$store.getters.stores.getStoreById(credit.storeId)
                            if (store.cityId != EnvironmentUtils.cityId) return
                            
                            if (ArrayUtils.isEmpty(store.pictures))
                            {
                                console.warn('store', store.id, 'has no pictures', store)
                            }

                            return (
                                <div class='element'>
                                    <img class='icon' src={store.pictures[0]} />
                                    <div class='middle'>
                                        <div class='title'>{store.name}</div>
                                        <div class='description'>Le {new Intl.DateTimeFormat('fr-FR').format(new Date(credit.timestamp))}</div>
                                    </div>
                                    <div class='right'>
                                        +{credit.amount} pts
                                    </div>
                                </div>
                            )
                        })
                    }
                    </div>
                </div>
                <div class='list' v-show={this.latestRewards.length > 0}>
                    <div class='title'>Dernières Récompenses</div>
                    <div class='elements'>
                    {
                            this.latestRewards.map(reward =>
                            {
                                const store = this.$store.getters.stores.getStoreById(reward.storeId)

                                return (
                                    <div class='element'>
                                        <img class='icon' src={store.pictures[0]} />
                                        <div class='middle'>
                                            <div class='title'>{store.name}</div>
                                            <div class='description'>{reward.reward}</div>
                                        </div>
                                        <div class='right'>
                                            -{reward.amount} pts
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        )
    },

    data () 
    {
        return {
            scanCode: null
        }
    },

    computed:
    {
        stores ()
        {
            return this.$store.state.stores.storeList
        },

        user ()
        {
            return this.$store.state.user
        },

        card ()
        {
            return this.$store.state.loyaltyCard.card
        },

        storeCardConfigs ()
        {
            return this.$store.state.storeLoyaltyCard.storeConfigs
        },

        cardCumuledBalance ()
        {
            return this.$store.getters.loyaltyCard.getCumuledBalance
        },

        latestCredits ()
        {
            return this.$store.state.loyaltyCard.latestCredits
        },

        latestRewards ()
        {
            return this.$store.state.loyaltyCard.latestRewards
        },
    },

    mounted ()
    {
        shiny('.card-wrapper', {gradient: { colors:[ [0, '#fff', 0.8], [0.1, '#fff', 0.5], [0.3, '#fff', 0.1], [0.5, '#fff', 0] ] }})
        setTimeout(() =>
        {
            if (this.$refs.card) DOMUtils.animateCSS(this.$refs.card.$el, 'swing', '0.5s')
        }, 200)
        this.checkForBalanceUpdateRoutine()
    },

    methods:
    {
        async onCardClicked ()
        {
            if (!this.$refs.isCardFlipped)
            {
                if (!this.scanCode) await this.generateScanCode();
            }
        },

        async generateScanCode ()
        {
            this.scanCode = await LoyaltyCardServices.generateCardScanCode(EnvironmentUtils.cityId, this.user.token, this.card.cardId)
        },

        onStoreBalanceCardClicked (store)
        {
            this.$router.push({ name: 'LoyaltyCardStorePage', params: {storeId: store.id} })
        },

        async checkForBalanceUpdateRoutine ()
        {
            if (this.card.cardId && this.scanCode)
            {
                const latest = (await LoyaltyCardServices.fetchCardLatestCredits(EnvironmentUtils.cityId, this.user.token, this.card.cardId, 1))[0];
                if (latest)
                {
                    const secondsSinceLastCredit = (new Date() - new Date(latest.timestamp)) / 1000
                    if (secondsSinceLastCredit < 10)
                    {
                        LoyaltyCardFrame.initFrame(this.$store);
                        this.$refs.card.isCardFlipped = false
                        DeviceUtils.vibrate(500)
                        for (let i = 0; i < 100; i++) ParticlesUtils.createParticle({ duration: [0, 6000], delay: [0, 200] })
                        for (let i = 0; i < 5; i++) ParticlesUtils.createParticle({ size: [50, 100], duration: [0, 5000], delay: [200, 600], text: ['⭐'] })
                        const store = this.$store.getters.stores.getStoreById(latest.storeId);
                        DialogUtils.showChatBubble({ message: `Vous avez gagné ${latest.amount} points chez ${store.name} !` })
                        await AsyncUtils.sleep(10000)
                    }
                }
            }

            await AsyncUtils.sleep(3000);
            this.checkForBalanceUpdateRoutine()
        }
    },

    components:
    {
        LoyaltyCardStoreBalanceCard,
        LoadingDots,
        Countdown,
        LoyaltyCard,
        BackgroundIllustration,
        AlertBubble
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';
@import '~@/styles/animations.less';

#loyalty-card-overview-view
{
    padding: 5vh 5vw;

    .stats
    {
        padding: 2vh 0;
    }

    .row
    {
        display: flex;
        flex-direction: row;
    }

    .background-illustration
    {
        margin-top: initial;
    }

    #credit-info
    {
        width: 100%;

        > .description
        {
            font-size: 110%;
            color: var(--theme-text-color-extra-light);
            margin-bottom: 6px;
        }

        > .value
        {
            font-size: 35px;
            font-weight: bold;

            > .sub-value
            {
                font-size: 35%;
                margin-left: 5px;
                color: var(--theme-text-color-extra-light);
                font-weight: initial;
                display: inline-block;
            }
        }
    }

    #help-sign
    {
        display: flex;
        flex-direction: row;
        justify-content: right;
        margin-top: auto;
        font-size: 11px;
        color: var(--theme-background-text-color-heavy);
        fill: var(--theme-background-text-color-heavy);
        transform: rotate(8deg);

        #help-text
        {
        }

        #help-arrow
        {
            width: 25px;
            height: 25px;
            transform: rotateZ(50deg) rotateX(180deg);
            fill: inherit;
            margin-left: -40px;
            margin-top: 20px;
        }
    }

    > .list
    {
        margin-bottom: 40px;

        > .title
        {
            font-size: 125%;
            font-weight: bold;
            margin-bottom: 20px;
        }

        > .description
        {
            color: var(--theme-text-color-extra-light);
            font-size: 12px;
            margin-bottom: 15px;
            margin-top: -12px;
        }

        > .elements
        {
            .balance-card
            {
                &:not(:first-of-type)
                {
                    margin-top: 10px;
                }
            }

            > .element
            {
                background-color: var(--theme-content-background-color);
                padding: 15px 20px;
                border-radius: 5px;
                box-shadow: var(--theme-box-shadow-sharp);
                display: flex;
                flex-direction: row;
                align-items: center;
                margin-bottom: 8px;

                > .icon
                {
                    width: 50px;
                    height: 50px;
                    border-radius: 6px;
                }

                > .middle
                {
                    width: 50%;
                    margin-left: 20px;

                    > .title
                    {
                        font-size: 85%;
                        font-weight: bold;
                    }
                    > .description
                    {
                        font-size: 80%;
                        margin-top: 2px;
                        color: var(--theme-text-color-extra-light);
                    }
                }

                > .right
                {
                    margin-left: auto;
                    text-align: right;

                    font-size: 90%;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/LoyaltyCardOverview.vue